export default __webpack_public_path__ + "static/media/img-ltsh-9.62c8c588.png";